import React, { useEffect } from "react";
import M from "materialize-css";
import "./intimass.css";

function PageIntimass() {
  useEffect(() => {
    M.Modal.init(document.querySelectorAll(".modal"), {});
    M.Collapsible.init(
      document.querySelectorAll(".collapsible.procedimentos"),
      {}
    );
  }, []);

  const procedimentos = [
    {
      id: "modal01",
      titulo: "Ninfoplastia",
      descricao: "Conforto e estética íntima",
      imagem: "/images/procedimentos/ninfoplastia.png",
      modalContent: {
        titulo: "Ninfoplastia",
        descricao:
          "A ninfoplastia, ou redução dos pequenos lábios, é uma cirurgia plástica íntima indicada para pacientes que desejam reduzir o tamanho ou corrigir assimetrias dos pequenos lábios. O procedimento proporciona maior conforto durante atividades físicas e uso de roupas justas, além de melhorar a autoestima. A técnica é realizada com incisões precisas para preservar a sensibilidade e a funcionalidade da região. As cicatrizes são discretas e posicionadas de forma a ficarem pouco visíveis.",
        perguntas: [
          {
            pergunta: "Quem pode fazer ninfoplastia?",
            resposta:
              "Pacientes com desconforto estético ou funcional causado pelo tamanho dos pequenos lábios.",
          },
          {
            pergunta:
              "É possível realizar outras cirurgias íntimas simultaneamente?",
            resposta:
              "Sim, procedimentos como lipoaspiração pubiana, e/ou preenchimentos em grande lábios, podem ser combinados, a depender das suas expectativas e nossa avaliação.",
          },
          {
            pergunta: "Quanto tempo dura a recuperação?",
            resposta:
              "A recuperação inicial leva cerca de 7 a 10 dias, com retorno gradual às atividades do cotidiano, sem esforços físicos.",
          },
          {
            pergunta: "A sensibilidade será preservada?",
            resposta:
              "Sim, a técnica é planejada para manter a sensibilidade da região.",
          },
          {
            pergunta: "O procedimento afeta a função sexual?",
            resposta:
              "Não. A cirurgia é segura e não interfere na funcionalidade sexual.",
          },
        ],
      },
    },
    {
      id: "modal02",
      titulo: "Lipoaspiração Pubiana",
      descricao: "Harmonia na região íntima",
      imagem: "/images/procedimentos/lipo_pubiana.png",
      modalContent: {
        titulo: "Lipoaspiração Pubiana",
        descricao:
          "A lipoaspiração pubiana é um procedimento que remove o excesso de gordura na região do púbis, proporcionando um contorno mais discreto e harmonioso. Indicada para pacientes que se sentem desconfortáveis com o volume na área, a técnica melhora a estética e o conforto em situações do dia a dia. O procedimento é realizado com pequenas incisões e garante cicatrizes discretas, posicionadas estrategicamente para ficarem pouco visíveis. A lipoaspiração pubiana é segura e planejada de forma personalizada, considerando as necessidades de cada paciente.",
        perguntas: [
          {
            pergunta: "Quem pode fazer lipoaspiração pubiana?",
            resposta:
              "Pacientes com excesso de gordura na região púbica que desejam melhorar o contorno íntimo.",
          },
          {
            pergunta: "As cicatrizes são visíveis?",
            resposta:
              "Não. Elas são pequenas e ficam posicionadas em áreas pouco perceptíveis.",
          },
          {
            pergunta: "Quanto tempo dura a recuperação?",
            resposta:
              "A recuperação inicial leva de 7 a 10 dias, com retorno gradual às atividades do cotidiano, sem esforços físicos.",
          },
          {
            pergunta: "Os resultados são permanentes?",
            resposta:
              "Sim, mas podem ser influenciados por alterações de peso.",
          },
          {
            pergunta: "O procedimento afeta a sensibilidade?",
            resposta:
              "Não. A técnica é segura e preserva a sensibilidade da região.",
          },
        ],
      },
    },
    {
      id: "modal03",
      titulo: "Lifting Pubiano",
      descricao: "Rejuvenescimento da região íntima",
      imagem: "/images/procedimentos/lifting_pubiano.png",
      modalContent: {
        titulo: "Lifting Pubiano",
        descricao:
          "O lifting pubiano é uma cirurgia plástica que eleva e reposiciona o tecido na região do púbis, corrigindo flacidez e excesso de pele. Indicada para pacientes que apresentam alterações devido ao envelhecimento ou grandes perdas de peso, a técnica devolve firmeza e proporção à área íntima. O procedimento é realizado com incisões discretas, geralmente posicionadas na linha das roupas íntimas, garantindo cicatrizes pouco perceptíveis. A cirurgia pode ser combinada com outros procedimentos para um rejuvenescimento mais completo.",
        perguntas: [
          {
            pergunta: "Quem pode fazer lifting pubiano?",
            resposta:
              "Pacientes com flacidez ou excesso de pele na região pubiana que desejam melhorar a estética.",
          },
          {
            pergunta: "As cicatrizes são visíveis?",
            resposta:
              "Não. Elas ficam posicionadas estrategicamente na linha das roupas íntimas.",
          },
          {
            pergunta: "Quanto tempo dura a recuperação?",
            resposta:
              "A recuperação inicial leva de 10 a 14 dias, com retorno gradual às atividades do cotidiano, sem esforços físicos.",
          },
          {
            pergunta: "Os resultados são permanentes?",
            resposta:
              "Sim, mas podem ser influenciados por alterações de peso ou envelhecimento natural.",
          },
          {
            pergunta: "O procedimento afeta a função sexual?",
            resposta:
              "Não. A técnica é segura e não interfere na funcionalidade sexual.",
          },
        ],
      },
    },
    {
      id: "modal04",
      titulo: "Redução de Grandes Lábios",
      descricao: "Equilíbrio e estética íntima",
      imagem: "/images/procedimentos/reducao_labios.png",
      modalContent: {
        titulo: "Redução de Grandes Lábios",
        descricao:
          "A redução de grandes lábios é uma cirurgia plástica indicada para pacientes que desejam diminuir o tamanho ou corrigir a flacidez dos grandes lábios. O procedimento melhora o conforto em atividades físicas e uso de roupas justas, além de proporcionar maior harmonia na região íntima. A técnica é realizada com incisões precisas, preservando a sensibilidade e a funcionalidade. As cicatrizes são discretas e posicionadas de forma estratégica para resultados naturais.",
        perguntas: [
          {
            pergunta: "Quem pode fazer redução de grandes lábios?",
            resposta:
              "Pacientes com desconforto estético ou funcional devido ao tamanho ou flacidez dos grandes lábios.",
          },
          {
            pergunta: "As cicatrizes são visíveis?",
            resposta:
              "Não. Elas são discretas e ficam posicionadas em áreas pouco perceptíveis.",
          },
          {
            pergunta: "Quanto tempo dura a recuperação?",
            resposta:
              "A recuperação inicial leva de 7 a 10 dias, com retorno gradual às atividades do cotidiano, sem esforços físicos.",
          },
          {
            pergunta: "A sensibilidade será preservada?",
            resposta:
              "Sim, a técnica é planejada para manter a sensibilidade da região.",
          },
          {
            pergunta: "Os resultados são permanentes?",
            resposta:
              "Sim, mas podem ser influenciados por fatores como envelhecimento e alterações hormonais.",
          },
        ],
      },
    },
    {
      id: "modal05",
      titulo: "Aumento de Grandes Lábios",
      descricao: "Volume e revitalização íntima",
      imagem: "/images/procedimentos/aumento_labios.png",
      modalContent: {
        titulo: "Aumento de Grandes Lábios",
        descricao:
          "O aumento de grandes lábios é um procedimento que utiliza gordura do próprio corpo ou preenchedores como ácido hialurônico para restaurar o volume e melhorar a aparência da região íntima. Indicada para pacientes que desejam rejuvenescer ou equilibrar as proporções dos grandes lábios, a técnica oferece resultados naturais e discretos. A gordura é retirada por lipoaspiração de áreas doadoras, processada e injetada nos grandes lábios. Quando utilizado preenchedores, o procedimento é minimamente invasivo e pode até ser realizado em consultório.",
        perguntas: [
          {
            pergunta: "Quem pode fazer aumento de grandes lábios?",
            resposta:
              "Pacientes que desejam restaurar o volume ou rejuvenescer os grandes lábios.",
          },
          {
            pergunta: "As cicatrizes são visíveis?",
            resposta:
              "Não. As técnicas são realizadas com incisões mínimas ou sem cortes aparentes.",
          },
          {
            pergunta: "Quanto tempo dura a recuperação?",
            resposta:
              "A recuperação inicial leva de 5 a 7 dias, com retorno rápido às atividades do cotidiano, sem esforços físicos.",
          },
          {
            pergunta: "Os resultados são permanentes?",
            resposta:
              "A gordura enxertada tem resultados duradouros, mas uma parte pode ser reabsorvida pelo corpo.",
          },
          {
            pergunta: "O procedimento afeta a funcionalidade íntima?",
            resposta:
              "Não. As técnicas são seguras e não interferem na funcionalidade da região.",
          },
        ],
      },
    },
    {
      id: "modal06",
      titulo: "Redução do Capuz Clitoriano",
      descricao: "Conforto e estética íntima",
      imagem: "/images/procedimentos/clitoris.png",
      modalContent: {
        titulo: "Redução de Capuz Clitoriano",
        descricao:
          "A redução do capuz clitoriano é uma cirurgia plástica que remove o excesso de pele ao redor do clitóris, melhorando a exposição e a estética da região íntima. Indicada para pacientes com desconforto funcional ou estético, a técnica proporciona maior equilíbrio e confiança. O procedimento é realizado com incisões precisas, preservando a sensibilidade e a funcionalidade. As cicatrizes são pequenas e posicionadas de forma a ficarem discretas.",
        perguntas: [
          {
            pergunta: "Quem pode fazer redução de capuz clitoriano?",
            resposta:
              "Pacientes que desejam corrigir excesso de pele ao redor do clitóris por razões estéticas ou funcionais.",
          },
          {
            pergunta: "As cicatrizes são visíveis?",
            resposta:
              "Não. Elas são pequenas e ficam posicionadas em áreas pouco perceptíveis.",
          },
          {
            pergunta: "Quanto tempo dura a recuperação?",
            resposta:
              "A recuperação inicial leva de 7 a 10 dias, com retorno gradual às atividades do cotidiano, sem esforços físicos.",
          },
          {
            pergunta: "A sensibilidade será preservada?",
            resposta:
              "Sim, a técnica é planejada para manter a sensibilidade da região.",
          },
          {
            pergunta: "O procedimento afeta a função sexual?",
            resposta:
              "Não. A cirurgia é segura e não interfere na funcionalidade sexual.",
          },
        ],
      },
    },
  ];

  return (
    <div>
      <div>
        <h3 className="titulo-cirurgias-page-intimas">Íntimas</h3>
      </div>

      {procedimentos.map((procedimento, index) => (
        <div
          key={index}
          className="row-page-intimas"
          id={`containerProcedimentosText${index % 2 === 0 ? "Right" : "Left"}`}
        >
          <div className="col-page-intimas s12">
            <div
              className={`hoverable container-page-intimas ${index % 2 === 0 ? "even" : "odd"}`}
            >
              {/* Imagem (50%) */}
              <div className="image-container-page-intimas">
                <img src={procedimento.imagem} alt={procedimento.titulo} />
              </div>
              {/* Texto (50%) */}
              <div
                className={`text-container-page-intimas ${index % 2 === 0 ? "right" : "left"}`}
              >
                <h5 className="card-title-page-intimas">
                  {procedimento.titulo}
                </h5>
                <p className="card-description-page-intimas">
                  {procedimento.descricao}
                </p>
                <a
                  className="modal-trigger custom-btn"
                  href={`#${procedimento.id}`}
                >
                  Saiba mais
                </a>
              </div>
            </div>
          </div>

          {/* Modal */}
          <div id={procedimento.id} className="modal">
            <a href="#!" className="modal-close btn-close-icon">
              <i className="material-icons">close</i>
            </a>
            <div className="modal-content-page-intimas">
              <h4 className="modal-title-page-intimas">
                {procedimento.modalContent.titulo}
              </h4>
              <p className="modal-description-page-intimas">
                {procedimento.modalContent.descricao}
              </p>
              <h5 className="questions-title-page-intimas">
                Dúvidas frequentes
              </h5>
              <ul className="collapsible procedimentos">
                {procedimento.modalContent.perguntas.map((pergunta, idx) => (
                  <li key={idx}>
                    <div className="collapsible-header questions-header-page-intimas">
                      {pergunta.pergunta}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M6 9l6 6 6-6" />
                      </svg>
                    </div>
                    <div className="collapsible-body questions-body-page-intimas">
                      <p className="question-page-intimas">
                        {pergunta.resposta}
                      </p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default PageIntimass;